import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import './assets/css/main.css';
import Router from './router/Router';


function App() {
  return (
    <>
      <main>
        <ChakraProvider>
          <Router />
        </ChakraProvider>
      </main>
    </>
  );
}

export default App;
